import React, { useState } from "react";
import RadioGroup from "sushiweb/RadioGroup";
import NoFooterModal from "../../Common/NoFooterModal";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";

const JobsOptionModal = (props) => {
  const jobTypeOptions = [
    {
      label: "TDS",
      value: "tds_deduction",
    },
    {
      label: "Rider Payout",
      value: "rider_payout",
    },
  ];

  const [selectedOption, setSelectedOption] = useState(props.activeJobType);

  const handleRadioOptionChange = (value) => {
    setSelectedOption(value);
  };

  return (
    <NoFooterModal
      header
      heading="Select Job Type"
      handleClose={props.handleModalClose}
      id="tdsAndRiderPayoutJobs_JobsOptions"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="jobsoptionsFormSubmitBtn"
            onClick={() => props.handleModalSubmit(selectedOption)}
            className="sushi-btn"
          >
            Submit
          </Button>
        </BottomSectionModal>
      }
    >
      <RadioGroup
        options={jobTypeOptions}
        onChange={handleRadioOptionChange}
        name="job-options"
        selected={selectedOption}
        defaultValue={selectedOption}
      />
    </NoFooterModal>
  );
};

export default JobsOptionModal;
